<template>
    <div class="map-section">
        <div class="map-toolbar">
            <el-checkbox v-model="showRangeCircles" @change="toggleRangeCircles">
                {{ $t('pointsManagement.showRange') }}
            </el-checkbox>
            <el-checkbox v-model="showOnlyEnabled" @change="refreshMapView">
                {{ $t('pointsManagement.showOnlyEnabled') }}
            </el-checkbox>
        </div>
        <div class="map-container">
            <KingLongMap ref="map" :mapId="'pointsMap'" @DrawPointCompleted="handlePointCompleted"
                @LoadCompleted="handleMapLoad" />
        </div>
    </div>
</template>

<script>
import KingLongMap from '@/components/KingLongMap.vue';

export default {
    name: 'PointsMap',
    components: {
        KingLongMap
    },
    props: {
        pointsList: {
            type: Array,
            default: () => []
        },
        selectedPointId: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            showRangeCircles: true,
            showOnlyEnabled: false
        };
    },
    watch: {
        pointsList: {
            deep: true,
            handler() {
                this.$nextTick(() => {
                    this.displayPointsOnMap();
                });
            }
        },
        selectedPointId() {
            this.$nextTick(() => {
                this.displayPointsOnMap();
            });
        }
    },
    methods: {
        handleMapLoad() {
            this.displayPointsOnMap();
        },
        displayPointsOnMap() {
            if (!this.$refs.map || !this.pointsList.length) return;

            this.$refs.map.clearAll();

            const displayList = this.showOnlyEnabled
                ? this.pointsList.filter(p => p.IsEnabled)
                : this.pointsList;

            displayList.forEach(point => {
                const lng = parseFloat(point.Longitude);
                const lat = parseFloat(point.Latitude);
                if (isNaN(lng) || isNaN(lat)) return;

                const isSelected = point.WayPointID === this.selectedPointId;

                this.$refs.map.addMarker(
                    point.WayPointID,
                    point.WayPointName + (point.IsEnabled ? '' : ' [' + this.$t('pointsManagement.disabled') + ']'),
                    lng,
                    lat,
                    null,
                    () => {
                        this.$emit('select-point', point);
                    }
                );

                if (this.showRangeCircles && point.RangeRadius) {
                    this.$refs.map.addCircle(
                        'circle_' + point.WayPointID,
                        { lng, lat },
                        point.RangeRadius,
                        isSelected ? 3 : 1,
                        isSelected ? '#409EFF' : (point.IsEnabled ? '#67C23A' : '#909399'),
                        isSelected ? 'rgba(64,158,255,0.1)' : (point.IsEnabled ? 'rgba(103,194,58,0.05)' : 'rgba(144,147,153,0.05)')
                    );
                }
            });
        },
        toggleRangeCircles() {
            this.displayPointsOnMap();
        },
        refreshMapView() {
            this.displayPointsOnMap();
        },
        handlePointCompleted(lng, lat) {
            this.$emit('draw-point', lng, lat);
        },
        setCenter(lng, lat) {
            if (this.$refs.map) {
                this.$refs.map.setCenter(lng, lat);
            }
        }
    }
};
</script>

<style scoped>
.map-section {
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.map-toolbar {
    display: flex;
    gap: 16px;
    margin-bottom: 8px;
    padding: 6px 12px;
    background: #f5f7fa;
    border-radius: 4px;
    align-items: center;
}

.map-container {
    flex: 1;
    min-height: 500px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
}

@media (max-width: 1200px) {
    .map-container {
        min-height: 400px;
    }
}
</style>